import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSwitchInput} from "../abstract-switch-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopSwitchInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-switch-input",
    templateUrl: "./pop-switch-input.component.html"
})
export class FUIPopSwitchInputComponent extends FUIAbstractSwitchInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
